export enum RotoMachineRejectedPartReason {
    MISSING_HARDWARE = 'missing hardware',
    WRONG_COLOR = 'wrong color',
    WRONG_WEIGHT = 'wrong weight',
}
